import meatapp from "@/assets/images/services/mobile-app/mobile-app.webp";

import performance from "@/assets/icons/services/mobileApp/performance.png";
import qa from "@/assets/icons/services/mobileApp/qa.svg";
import roadmap from "@/assets/icons/services/mobileApp/roadmap.svg";
import exection from "@/assets/icons/services/mobileApp/exection.svg";
import launch from "@/assets/icons/services/mobileApp/launch.svg";
import requirement from "@/assets/icons/services/mobileApp/requirement.svg";
import security from "@/assets/icons/services/mobileApp/security.png";
import scaleup from "@/assets/icons/services/mobileApp/scaleup.svg";
import uiux from "@/assets/icons/services/mobileApp/uiux-icon.svg";
import scalable from "@/assets/icons/services/mobileApp/scaleup.svg";

import realestate from "@/assets/icons/services/mobileApp/realestate.svg";
import ecommerce from "@/assets/icons/services/mobileApp/ecommerce.svg";
import entertainment from "@/assets/icons/services/mobileApp/entertainment.svg";
import logistics from "@/assets/icons/services/mobileApp/logistics.svg";
import health from "@/assets/icons/services/mobileApp/health.svg";
import edtech from "@/assets/icons/services/mobileApp/edtech.svg";
import manufacturing from "@/assets/icons/services/mobileApp/manufacturing.svg";
import fintech from "@/assets/icons/services/mobileApp/fintech.svg";

import cloud from "@/assets/images/services/mobile-app/cloud.webp";


import webapp from "@/assets/images/services/mobile-app/ios.webp";
import aipower from "@/assets/images/services/mobile-app/ai-powered.webp";
import crossplatform from "@/assets/images/services/mobile-app/cross-platform.webp";
import mobileapp from "@/assets/images/services/mobile-app/android.webp";
import process from "@/assets/images/services/mobile-app/process.webp";

import impact from "@/assets/icons/services/mobileApp/impact.svg";
import uiuxImg from "@/assets/images/services/mobile-app/ui-ux.webp";
import appgrowth from "@/assets/images/services/mobile-app/app-growth.webp";

import transparency from "@/assets/icons/services/mobileApp/transparency.png";
import team from "@/assets/icons/services/mobileApp/team.svg";
import speed from "@/assets/icons/services/mobileApp/speed.svg";

import iosIcon from "@/assets/icons/services/mobileApp/ios.svg";
import andriodIcon from "@/assets/icons/services/mobileApp/andriod.svg";
import crossIcon from "@/assets/icons/services/mobileApp/cross.svg";
import aiIcon from "@/assets/icons/services/mobileApp/ai.svg";
import uiuxIcon from "@/assets/icons/services/mobileApp/uiux.svg";
import appIcon from "@/assets/icons/services/mobileApp/app.svg";

const mobileAppServices = {
  "mobile-app-development": {
    slug: "mobile-app-development",
    name: "Mobile App Development",
    hero: {
      title:
        "We Build Revenue-Generating Mobile Apps for Startups & Enterprises",
      description:
        "From idea to App Store in 90 days, turn your concept into a high-performing mobile app. We build scalable iOS, Android, and cross-platform apps for real users and growth. ",
      image: meatapp,
      statItems: [
        { label: "App Delivery", value: "100%" },
        { label: "On-Time Delivery", value: "98%" },
        { label: "Global Clients", value: "50+" },
      ],
    },

    industryGrowth: {
      title: "Custom Apps Built for Industry-Specific Growth",
      description:
        "We Don’t Build Generic Apps. We Build Apps That Understand The Rules Of Your Industry.",
      cards: [
        {
          id: 1,
          slug: "manufacturing",
          title: "Manufacturing",
          description: "Reduce downtime by 30% with our IoT solutions",
          icon: manufacturing,
          duration: 5,
        },
        {
          id: 2,
          slug: "ecommerce",
          title: "eCommerce",
          description: "Increase revenue by 45% with real-time inventory sync",
          icon: ecommerce,
          duration: 6,
        },
        {
          id: 3,
          slug: "entertainment",
          title: "Entertainment",
          description:
            "Streaming apps, gaming platforms, smart media, live ticketing",
          icon: entertainment,
          duration: 5.5,
        },
        {
          id: 4,
          slug: "real-estate",
          title: "Real Estate",
          description:
            "Property listing, virtual tours, mortgage calculators, CRM sync",
          icon: realestate,
          duration: 6.5,
        },
        {
          id: 5,
          slug: "edtech",
          title: "EdTech",
          description:
            "LMS apps, smart learning AI tutors, online course delivery",
          icon: edtech,
          duration: 5.8,
        },
        {
          id: 6,
          slug: "logistics",
          title: "Logistics",
          description:
            "Last-mile tracking, fleet management, smart dispatch apps",
          icon: logistics,
          duration: 6.2,
        },
        {
          id: 7,
          slug: "healthcare",
          title: "Healthcare",
          description:
            "HIPAA compliant telemedicine, EHR integration, patient portals",
          icon: health,
          duration: 5.3,
        },
        {
          id: 8,
          slug: "fintech",
          title: "Fintech",
          description:
            "Digital wallets, lending apps, trading platforms, KYC tools",
          icon: fintech,
          duration: 6.8,
        },
      ],
    },

    solutions: {
      title: "Digital Solutions We Create",

      description:
        "Every app type, every platform. We handle the full build cycle, so you don't have to stitch together 4 different agencies.",

      cards: [
        {
          id: 1,
          title: "iOS App Development",
          description:
            "Native Swift & SwiftUI apps built for performance and seamless App Store approval",
          image: webapp,
          icon: appIcon,
          button: "Explore More",
          className: "purple-card",
        },

        {
          id: 2,
          title: "Android App Development",
          description:
            "Kotlin-powered Android apps that run smoothly on every device",
          image: mobileapp,
          icon: uiuxIcon,
          button: "View Apps",
          className: "blue-card",
        },

        {
          id: 3,
          title: "Cross-Platform Apps",
          description:
            "One codebase. Two platforms. Native-like apps with smarter cost and faster delivery.",
          image: crossplatform,
          icon: aiIcon,
          button: "Discover AI",
          className: "dark-card",
        },

        {
          id: 4,
          title: "AI-Powered App Features",
          description:
            "AI that works -ML, NLP, and vision built for real-world impact",
          image: aipower,
          icon: crossIcon,
          button: "Learn More",
          className: "glass-card",
        },
        {
          id: 5,
          title: "UI/UX Design",
          description:
            "Interfaces users love from the first tap, from Figma to pixel-perfect, accessible screens",
          image: uiuxImg,
          icon: andriodIcon,
          button: "Learn More",
          className: "glass-card",
        },
        {
          id: 6,
          title: "App Maintenance & Growth",
          description:
            "Launch is just the beginning. We monitor, optimize, and scale your app as you grow",
          image: appgrowth,
          icon: iosIcon,
          button: "Learn More",
          className: "glass-card",
        },
      ],
    },

    chooseUs: {
      title: "Why Leading Teams Choose Us",
      description:
        "A product-first approach focused on speed, transparency, and scalable apps that drive real business growth.",
      items: [
        {
          icon: impact,
          title: "Built for Business Impact",
          description:
            "We don’t just build apps, we build revenue-generating products",
        },
        {
          icon: speed,
          title: "Speed Without Compromise",
          description:
            "Launch in 90 days with structured sprints and clear milestones",
        },
        {
          icon: transparency,
          title: "Full Transparency",
          description: "No black boxes. You see progress every step of the way",
        },
        {
          icon: team,
          title: "Product Thinking Team",
          description:
            "We challenge ideas, improve flows, and think like co-founders",
        },
        {
          icon: scalable,
          title: "Scalable Architecture",
          description: "Built to handle growth from day one",
        },
        {
          icon: transparency,
          title: "Scalable Architecture",
          description: "Built to handle growth from day one",
        },
      ],
    },

    process: {
      title:
        "From Discovery to Deployment - A Process Built for Successful Products",

      description:
        "We follow a streamlined product development process designed to move ideas from concept to scalable digital experiences with speed, clarity, and long-term growth in mind.",

      processItems: [
        {
          id: 1,
          icon: requirement,
          title: "Requirements Gathering",
          description:
            "We learn your goals, users, scope, and tech decisions. all defined together.",
          image: process,
        },

        {
          id: 2,
          icon: roadmap,
          title: "Roadmap & Strategy",
          description:
            "Full feature map, tech stack recommendation, timeline, and fixed-price quote.",
          image: process,
        },

        {
          id: 3,
          icon: uiux,
          title: "UI/UX Design",
          description:
            "Wireframes to high-fidelity Figma prototypes. You approve before a single line of code.",
          image: process,
        },

        {
          id: 4,
          icon: exection,
          title: "Execution Phase",
          description:
            "2-week sprints with working demos every fortnight. You see progress, not promises.",
          image: process,
        },

        {
          id: 5,
          icon: qa,
          title: "QA & Testing",
          description:
            "Manual + automated testing across 50+ real devices. We break it before your users can.",
          image: process,
        },

        {
          id: 6,
          icon: launch,
          title: "Launch & Scale",
          description:
            "App Store submission, ASO, analytics setup, and 90-day post-launch support included.",
          image: process,
        },
      ],
    },

    codeaudit: {
      title: "Is your current app slow or buggy? Get a free Code Audit",

      description:
        "Slow performance, frequent crashes, or a 'broken' codebase shouldn't stop your growth. If your current agency or freelancer let you down, we’re here to fix it.",

      points: [
        {
          id: 1,
          icon: performance,
          title: "Performance Bottlenecks",
          description: "Identify why your app is slow or lagging.",
        },

        {
          id: 2,
          icon: security,
          title: "Security Vulnerabilities",
          description: "Find hidden risks before they become threats.",
        },

        {
          id: 3,
          icon: scaleup,
          title: "Scalability Check",
          description: "See if your code can handle 10x more users.",
        },

        {
          id: 4,
          icon: uiux,
          title: "User Experience (UX) Gaps",
          description: "Fix the flow issues that make users uninstall.",
        },
      ],
    },

    cta: {
      title: "Bring Your Mobile App Vision to Life",
      description:
        "Ready to create a powerful mobile app that engages your users? Contact GSUS Star Software today to develop custom, scalable mobile applications designed to meet your business needs.",
      button: "Let's Talk",
    },

    faq: {
      items: [
        {
          question: "Why Choose GSUS Star Software for Mobile App Development?",
          answer:
            "With over 13 years of experience in mobile app development, GSUS Star Software has perfected a process that ensures high productivity and efficiency. We stay at the forefront of emerging technologies to provide innovative, first-class mobile application development services. Our expertise spans the latest tech advancements, from blockchain for enhanced security to AI-powered automation. We also offer post-launch support to ensure your app's continuous success.",
        },
        {
          question: "What is the Cost of Mobile App Development in 2024?",
          answer:
            "The cost of mobile app development varies based on factors such as developer rates, project complexity, and development time. While it's not as expensive as you might think, there's no one-size-fits-all answer. Contact our experts to discuss your specific needs and get an accurate estimate.",
        },
        {
          question:
            "How Do I Choose the Right Mobile App Development Platform?",
          answer:
            "Who is the target audience? What are their expectations? What is the budget for development?What are the security requirements? How will the app integrate with other platforms? Our team can help you navigate these questions to select the best platform for your project.",
        },
        {
          question:
            "How Do You Manage Product Development and Mobile Application Services?",
          answer:
            "Time & Material or Fixed Price: We provide an experienced Project Manager to oversee the entire process. Dedicated Team: You have full control over team management, allowing you to steer the project as needed",
        },
        {
          question:
            "What is the Difference Between Cross-Platform and Hybrid Mobile App Development?",
          answer:
            "Cross-platform and hybrid mobile app development both aim to support multiple platforms, but they are different approaches. Cross-platform development uses a single codebase to create apps for multiple platforms, ensuring consistency across devices. Hybrid development combines native and web technologies, allowing the app to function across different environments. Each has its own advantages depending on your project’s needs.",
        },
        {
          question: "How Long Does It Take to Develop a Mobile App?",
          answer:
            "The development timeline for a mobile app varies depending on its complexity, features, and the chosen platform. On average, it can take several weeks to several months. We work with you to establish a clear timeline and milestones to ensure timely delivery.",
        },
        {
          question: "What Post-Launch Support Do You Offer?",
          answer:
            "After your app goes live, we provide ongoing support to ensure it runs smoothly. This includes regular updates, troubleshooting, and enhancements to keep your app up-to-date and performing well in the market.",
        },
      ],
    },

    contact: {
      title: "Start Your App Project Today ",
      description:
        "We’ve helped 300+ founders, product teams, and enterprises go from idea to App Store, on time, on budget, and ready to scale. Fill out the form and our team will get in touch to discuss your app and the next steps.",
    },
  },
};
export default mobileAppServices;
